import accountService from './accountService';
import accountServiceMock from './accountServiceMock';
import bookmarkService from './bookmarkService';
import bookmarkServiceMock from './bookmarkServiceMock';
import loginService from './loginService';
import loginServiceMock from './loginServiceMock';
import membershipService from './membershipService';
import membershipServiceMock from './membershipServiceMock';
import orderService from './orderService';
import orderServiceMock from './orderServiceMock';
import profileService from './profileService';
import profileServiceMock from './profileServiceMock';
import searchService from './searchService';
import searchServiceMock from './searchServiceMock';
import smartStreetServiceMock from './smartStreetServiceMock';
import smartStreetService from './smartStreetService';

const isMock = window.name === 'true';

export const { getSsoClaims, login } = isMock ? loginServiceMock() : loginService();

export const {
  getAccount,
  getMembershipCertificateData,
  getContactEditData,
  getContactConfigData,
  saveEmailPassword,
  savePhone,
  getStatesForCountry,
  saveAddress,
  getAllEntries,
  saveHrMagazineSubscription,
  updatePreferences,
} = isMock ? accountServiceMock() : accountService();

export const { getBookmarksPaged, updateNote, deleteBookmark } = isMock
  ? bookmarkServiceMock()
  : bookmarkService();

export const { exportMembershipCard, exportMembershipCertificate } = isMock
  ? membershipServiceMock()
  : membershipService();

export const {
  getProfile,
  getProfilePhoto,
  getChaptersForState,
  updateProfile,
  deleteProfilePhoto,
  uploadProfilePhoto,
  saveProfilePhoto,
  getCollegeName,
  getDnbName,
} = isMock ? profileServiceMock() : profileService();

export const { getOrdersPaged, printOrders } = isMock ? orderServiceMock() : orderService();

export const { getSearchResults } = isMock ? searchServiceMock() : searchService();

export const { lookup } = isMock ? smartStreetServiceMock() : smartStreetService();

export const handleErrorResponse = error => {
  let message = '';
  if (!error.status && (!error.request || !error.response)) {
    message =
      'There seems to be some kind of network error. Please check your internet connection and try again.' +
      'status: ' +
      error.status +
      '. request: ' +
      error.request +
      '. response: ' +
      error.response;
  }
  if (error.response) {
    const { status, data } = error.response;

    if (status === 400) {
      message = 'Invalid request message';
    } else if (status === 401) {
      message = 'Invalid request message';
    } else if (status === 403) {
      message = 'Sorry, you are not allowed to be here!';
    } else if (status === 404) {
      message = "Sorry, We didn't find what you were looking for";
    } else if (status === 500) {
      if (data) {
        if (data.error?.message) {
          message = data.error?.message;
        } else {
          message = data;
        }
      } else {
        message = 'There seems to be some kind of error, please try again later';
      }
    } else {
      message = error.response.data.message;
    }
  }
  return message;
};
